import React from 'react';
import { MiddlePillNavbar } from './MiddlePillNavBar';
import { NavBarDropdown } from './NavBarDropdown';
import './Navbar.css';

export function MainPageNavbar({ activeTab, setActiveTab }) {
  return (
    <div className="page-navbar">
      <div className="navbar-container">
        <div className="navbar-center">
          <MiddlePillNavbar activeTab={activeTab} setActiveTab={setActiveTab} />
        </div>
        <div className="navbar-right">
          <NavBarDropdown />
        </div>
      </div>
    </div>
  );
}
